import React from 'react';

const ShowPassword = (props) => (
  <svg
    fill="#000000"
    width="20px"
    height="20px"
    viewBox="0 -16 544 544"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M272 400Q205 400 151 361 96 322 64 256 96 190 151 151 205 112 272 112 336 112 392 153 448 193 480 256 448 319 392 360 336 400 272 400ZM272 352Q312 352 340 324 368 296 368 256 368 216 340 188 312 160 272 160 232 160 204 188 176 216 176 256 176 296 204 324 232 352 272 352ZM272 312Q249 312 233 296 216 279 216 256 216 233 233 217 249 200 272 200 295 200 312 217 328 233 328 256 328 279 312 296 295 312 272 312Z" />
  </svg>
);

export default ShowPassword;

